import Intercom, { boot, shutdown, update } from '@intercom/messenger-js-sdk'

export const INTERCOM_APP_ID = 'vbqynnfs' // ваш app_id

// анонимный старт — вызывается один раз при загрузке приложения
export function initIntercom() {
  Intercom({ app_id: INTERCOM_APP_ID })
}

// поднять сессию с данными авторизованного юзера
export function bootIntercomUser(user) {
  boot({
    app_id: INTERCOM_APP_ID,
    user_id: user.id,
    name: user.name,
    email: user.email,
    created_at: user.createdAt, // unix timestamp
  })
}

export function updateIntercom(data = {}) {
  update(data)
}

export function shutdownIntercom() {
  shutdown()
  // если юзер уходит на анонимный режим - можно сразу заново забутить пустым
  Intercom({ app_id: INTERCOM_APP_ID })
}